import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ContactComponent } from './pages/contact/contact.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { MentionsLegalesComponent } from './pages/mentions-legales/mentions-legales.component';
import { TmaComponent } from './pages/tma/tma.component';
import { TmaNodejsComponent } from './pages/services/tma-nodejs/tma-nodejs.component';
import { TmaAngularComponent } from './pages/services/tma-angular/tma-angular.component';
import { TmaAndroidComponent } from './pages/services/tma-android/tma-android.component';
import { IntegrationIaComponent } from './pages/services/integration-ia/integration-ia.component';
import { ModernisationComponent } from './pages/modernisation/modernisation.component';
import { AgenceComponent } from './pages/agence/agence.component';
import { RessourcesComponent } from './pages/ressources/ressources.component';
import { RessourceDetailComponent } from './pages/ressource-detail/ressource-detail.component';
import { AngularMigrationComponent } from './pages/solutions/angular-migration/angular-migration.component';
import { NodeRescueComponent } from './pages/solutions/node-rescue/node-rescue.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'mentions-legales', component: MentionsLegalesComponent },
  { path: 'maintenance-tma-nodejs-angular', component: TmaComponent },
  { path: 'tma-nodejs', component: TmaNodejsComponent },
  { path: 'tma-angular', component: TmaAngularComponent },
  { path: 'tma-android', component: TmaAndroidComponent },
  { path: 'integration-ia', component: IntegrationIaComponent },
  { path: 'refonte-modernisation-legacy', component: ModernisationComponent },
  { path: 'agence-web-chateauroux-paris', component: AgenceComponent },
  { path: 'ressources', component: RessourcesComponent },
  { path: 'ressources/:id', component: RessourceDetailComponent },
  { path: 'solutions/migration-angularjs-vers-angular', component: AngularMigrationComponent },
  { path: 'solutions/sauvetage-application-nodejs', component: NodeRescueComponent },
  {
    path: 'simulateur-cii',
    loadComponent: () =>
      import('./pages/simulateur-cii/simulateur-cii.component').then(
        m => m.SimulateurCiiComponent
      ),
  },
  { path: '**', redirectTo: '' }
];